module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n    <label>\n        Direction\n        <select class="form-control" id="direction">\n            <option value="top">To top</option>\n            <option value="right">To right</option>\n            <option value="bottom">To bottom</option>\n            <option value="left">To left</option>\n        </select>\n    </label>\n\n    <label>Easing: <select class="form-control" id="slideOutEasing"></select></label>\n\n    <div class="zmags-input-control small columns">\n        <div class="pull-left">\n            <label data-unit="sec">Delay: <input type="number" step="0.1" min="0" name="delay"    id="delay"></label>\n        </div>\n        <div class="pull-right">\n            <label data-unit="sec">Time: <input type="number" step="0.1" min="0" name="duration" id="duration"></label>\n        </div>\n    </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/animations/slideOut/SlideOutAnimationPropertiesView.tpl
// module id = 1693
// module chunks = 0